import baseSlice from './_baseSlice.js';

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

export default castSlice;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_castSlice.js
// module id = 156
// module chunks = 41